export default __webpack_public_path__ + "static/media/pd2.8efa5946.jpg";